import { CheckoutProvider } from '@core/context/checkoutContext';
import { Outlet } from 'react-router-dom';

import { CheckoutHeader } from '@components/molecules/CheckoutHeader';
import { PoweredByAstroPay } from '@components/organisms/PoweredByAstroPay';

export const CheckoutTemplate = () => {
  return (
    <CheckoutProvider>
      <div className="flex flex-col bg-[#FAFAF9] p-4 h-full min-h-screen">
        <CheckoutHeader />

        <Outlet />

        <PoweredByAstroPay />
      </div>
    </CheckoutProvider>
  );
};
